export const Token = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M5.99984 2.66602C3.05317 2.66602 0.666504 5.05268 0.666504 7.99935C0.666504 10.946 3.05317 13.3327 5.99984 13.3327C8.9465 13.3327 11.3332 10.946 11.3332 7.99935C11.3332 5.05268 8.9465 2.66602 5.99984 2.66602ZM7.99984 6.99935H6.6665V10.3327H5.33317V6.99935H3.99984V5.99935H7.99984V6.99935ZM13.4998 2.49935L15.3332 3.33268L13.4998 4.16602L12.6665 5.99935L11.8332 4.16602L9.99984 3.33268L11.8332 2.49935L12.6665 0.666016L13.4998 2.49935ZM13.4998 11.8327L15.3332 12.666L13.4998 13.4993L12.6665 15.3327L11.8332 13.4993L9.99984 12.666L11.8332 11.8327L12.6665 9.99935L13.4998 11.8327Z"
      fill="#175CE5"
    />
  </svg>
);
